import React, { useState, useEffect } from 'react';
import { db } from '../firebase';
import { doc, getDoc } from 'firebase/firestore';

const MONTHS_ES = ['Enero','Febrero','Marzo','Abril','Mayo','Junio','Julio','Agosto','Septiembre','Octubre','Noviembre','Diciembre'];

function formatDate(dateKey) {
  const [y, m, d] = dateKey.split('-').map(Number);
  return `${d} de ${MONTHS_ES[m - 1]} ${y}`;
}

let cache = {};

export default function SermonNotes({ dateKey, navigate }) {
  const [html, setHtml]       = useState(cache[dateKey] || '');
  const [loading, setLoading] = useState(!cache[dateKey]);
  const [error, setError]     = useState('');

  useEffect(() => {
    if (cache[dateKey]) return;
    const fetch = async () => {
      try {
        const snap = await getDoc(doc(db, 'sermons', dateKey));
        if (snap.exists()) {
          cache[dateKey] = snap.data().html;
          setHtml(snap.data().html);
        } else {
          setError('Sermón no encontrado.');
        }
      } catch (e) {
        setError('No se pudo cargar el sermón.');
      } finally {
        setLoading(false);
      }
    };
    fetch();
  }, [dateKey]);

  return (
    <>
      {/* Back button */}
      <button
        onClick={() => navigate('sermon-calendar')}
        style={{
          background: 'var(--navy)', border: 'none', color: 'white',
          borderRadius: 10, padding: '10px 20px', fontSize: '0.85rem',
          fontWeight: 700, cursor: 'pointer', fontFamily: 'Inter, sans-serif',
          marginBottom: 16, display: 'inline-flex', alignItems: 'center', gap: 6,
        }}
      >
        ← Volver · {formatDate(dateKey)}
      </button>

      {loading && (
        <div style={{ textAlign: 'center', padding: '40px 0', color: 'var(--text-sub)' }}>Cargando sermón...</div>
      )}

      {error && (
        <div style={{ textAlign: 'center', padding: '40px 0', color: '#e53e3e' }}>{error}</div>
      )}

      {html && (
        <iframe
          srcDoc={html}
          style={{ width: '100%', border: 'none', borderRadius: 16, minHeight: '80vh' }}
          sandbox="allow-same-origin allow-popups"
          onLoad={e => {
            try {
              e.target.style.height = e.target.contentDocument.body.scrollHeight + 'px';
            } catch {}
          }}
        />
      )}
    </>
  );
}
